import type { DealerCode } from "@dealer-center/ddc-api-account-interface";
import type {
  InterstateOnChangeEvent,
  SearchInputChangeEventValue
} from "@dealer-center/core-components";
import {
  Modal,
  ModalContent,
  ModalFooter,
  TextInput,
  useToaster
} from "@dealer-center/core-components";
import { useState } from "react";
import { InputWithTypeahead } from "@dealer-center/ddc-pages-account-search-react";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import { useMapDealerCodeTypeToAccount } from "@dealer-center/ddc-pages-dealer-codes-fetch";
import { populateMappingConfig } from "./helper";
import { DuplicateDealerCodeValueWarning } from "./duplicate-dealer-code-value-warning";
interface DealerCodesAddCodeToDealerModalProps {
  show: boolean;
  close: () => void;
  dealerCode: DealerCode;
}
export const DealerCodesAddCodeToDealerModal = ({
  close,
  dealerCode,
  show
}: DealerCodesAddCodeToDealerModalProps) => {
  const [selectedDealer, setSelectedDealer] = useState<string | null>(null);
  const [
    addDealerCodeToDealerInputString,
    setAddDealerCodeToDealerInputString
  ] = useState<string | undefined | number>("");

  const { toastError, toastSuccess } = useToaster();
  const { mutate, isError, isSuccess, isPending } =
    useMapDealerCodeTypeToAccount();
  if (isError) {
    toastError(`Error adding dealer code to dealer`);
    close();
  }
  if (isSuccess) {
    toastSuccess(
      "Success",
      `Dealer code ${addDealerCodeToDealerInputString} added to ${selectedDealer}`
    );
    close();
  }

  return (
    <Modal
      className="sample-modal-dialog"
      footer={{
        primary: {
          label: "unused"
        },
        footerComponent: (
          <ModalFooter>
            <SaveAndCancel
              analyticsEventName="Dealer Code Add code to dealer"
              isDisabled={{
                save:
                  selectedDealer === null ||
                  addDealerCodeToDealerInputString === ""
              }}
              isSaving={isPending}
              saveButtonText="Add"
              onCancel={close}
              onSave={() => {
                if (
                  selectedDealer !== null &&
                  addDealerCodeToDealerInputString !== undefined
                ) {
                  const config = populateMappingConfig(
                    selectedDealer,
                    String(addDealerCodeToDealerInputString),
                    dealerCode.type
                  );
                  mutate(config);
                }
              }}
            />
          </ModalFooter>
        )
      }}
      header={`Add dealer code "${dealerCode?.type}" to dealer`}
      show={show}
      size="small"
      onHide={close}
    >
      <ModalContent>
        <InputWithTypeahead
          placeholder={"Dealer"}
          onInputChange={(
            event: InterstateOnChangeEvent<SearchInputChangeEventValue>
          ) => {
            const searchValue = event.target.value;
            if (typeof searchValue !== "string") return;
            setSelectedDealer(searchValue);
          }}
          onItemSelected={(selectedItem: string) => {
            setSelectedDealer(selectedItem);
          }}
          onSubmit={(searchValue: string) => {
            setSelectedDealer(searchValue);
          }}
        />
        <TextInput
          id="add-dealer-code-input"
          label="Value"
          name="add-dealer-code-input"
          value={addDealerCodeToDealerInputString?.toString()}
          onChange={e => {
            setAddDealerCodeToDealerInputString(e.target.value);
          }}
        />
        <DuplicateDealerCodeValueWarning
          currentAccountId={selectedDealer || ""}
          dealerCodeVType={dealerCode.type}
          dealerCodeValue={addDealerCodeToDealerInputString?.toString()}
        />
      </ModalContent>
    </Modal>
  );
};
